export default function open(url, target) {
	if (typeof document !== `undefined` && typeof window !== `undefined`) {
		const a = document.createElement('a');
		a.href = url;
		a.target = target || '_blank';
		a.rel = 'noopener noreferrer'
		a.click();
	}
}